import { Tabs } from "expo-router";
import { useI18n } from "@/context/I18nContext";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useIsWideScreen } from "@/hooks/useIsWideScreen";
import { Platform } from "react-native";
import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAuth } from "@/context/AuthContext";

/**
 * Staff dashboard layout — responsive navigation.
 *
 * Small screens: bottom tab bar (Home, Invitations, Applications, Admin Users).
 * Wide screens (≥768px web): ScreenHeader + content + PageFooter, no tabs.
 */
export default function StaffDashboardLayout() {
  const { t } = useI18n();
  const isWide = useIsWideScreen();
  const { bottom } = useSafeAreaInsets();
  const { hasAnyRole } = useAuth();

  const canAccessLocalization = hasAnyRole(["localization_staff", "admin", "super_admin"]);

  return (
    <Tabs
      screenOptions={{
        headerShown: isWide && Platform.OS === "web",
        header: (props) => <ScreenHeader {...props} />,
        tabBarActiveTintColor: "#FF1654",
        tabBarInactiveTintColor: "#9B9EA6",
        tabBarLabelStyle: {
          fontFamily: "InterDisplay-SemiBold",
          fontSize: 14,
          letterSpacing: 0.14,
        },
        tabBarStyle:
          isWide && Platform.OS === "web"
            ? { display: "none" }
            : {
                borderTopWidth: 1,
                borderTopColor: "#E4E7ED",
                backgroundColor: "#FFFFFF",
                paddingTop: 8,
                minHeight: 64 + bottom,
              },
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: t("staff.nav.home"),
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="home-outline" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="invitations"
        options={{
          title: t("staff.nav.invitations"),
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="file-document-outline" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="applications"
        options={{
          title: t("staff.nav.applications"),
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="clock-outline" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="localization"
        options={{
          title: t("staff.nav.localization"),
          href: canAccessLocalization ? undefined : null,
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="translate" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="users"
        options={{
          title: t("staff.nav.adminUsers"),
          tabBarIcon: ({ color, size }) => (
            <MaterialCommunityIcons name="account-outline" size={size} color={color} />
          ),
        }}
      />
    </Tabs>
  );
}
